import { Entry } from 'contentful';
import { ContentPageActionType } from './actions';
import { logSafelyToConsole } from 'utils';
import { ContentPageType } from 'types/Content';

const {
  GET_CONTENT_PAGE_REQUEST,
  GET_CONTENT_PAGE_SUCCESS,
  GET_CONTENT_PAGE_ERROR
} = ContentPageActionType;

export interface ContentPageState {
  loading: boolean;
  entry: Entry<ContentPageType> | undefined;
  pageNotFound: boolean;
}

export default function reducer(
  state: ContentPageState,
  action: {
    type: ContentPageActionType;
    payload: { entry: Entry<ContentPageType> } | null;
  }
): ContentPageState {
  const { type, payload } = action;

  logSafelyToConsole(type);
  switch (type) {
    case GET_CONTENT_PAGE_REQUEST: {
      return {
        ...state,
        loading: true,
        pageNotFound: false
      };
    }
    case GET_CONTENT_PAGE_SUCCESS: {
      if (payload) {
        const { entry } = payload;
        return {
          ...state,
          loading: false,
          pageNotFound: false,
          entry
        };
      } else {
        return {
          ...state,
          loading: false,
          pageNotFound: true
        };
      }
    }
    case GET_CONTENT_PAGE_ERROR: {
      return {
        ...state,
        loading: false,
        pageNotFound: true
      };
    }
    default:
      return state;
  }
}
